import { useState } from "react"
import { capitalize } from "humanize-plus"
import PropTypes from "prop-types"

import Modal from "shared/components/modal"
import classnames from "classnames"

import { sendPlatformSuggestion } from "shared/lib/graphql"

import webModal from "./web_modal.module.scss"
import styles from "./suggestion_modal.module.scss"

const SuggestionModal = ({
  channelId,
  feedbackTqaType,
  onClose,
  serviceName,
}) => {
  const [name, setName] = useState("")
  const [text, setText] = useState("")
  const [loading, setLoading] = useState(false)

  const onSubmit = async () => {
    setLoading(true)
    try {
      await sendPlatformSuggestion(
        channelId,
        feedbackTqaType,
        name,
        text
      )
      window.appendFlash("Your suggestion has been submitted.")
    } catch {
      window.appendFlash(
        "Something went wrong while submitting your suggestion. Please try again later."
      )
    }
    setLoading(false)
    onClose()
  }

  return (
    <span className={classnames(webModal["web-modal"], styles["suggestion-modal"])}>
      <Modal closeListener={onClose} show includeCloseX={false}>
        <h2 className="text-h2">
          Suggest a new {feedbackTqaType} for {serviceName}
        </h2>

        <div className="form">
          <div className="field">
            <label className="label" htmlFor="suggestion-name">
              What new {feedbackTqaType} would you like to suggest?
            </label>
            <input
              id="suggestion-name"
              type="text"
              placeholder={`${capitalize(feedbackTqaType)} name`}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="label" htmlFor="suggestion-text">
              How would you use this {feedbackTqaType}?
            </label>
            <textarea
              id="suggestion-text"
              placeholder={`Briefly describe this ${feedbackTqaType}`}
              value={text}
              onChange={e => setText(e.target.value)}
            />
          </div>
        </div>

        <div className={webModal.ctas}>
          <button type="button" className="button-tertiary button-cancel-link" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            disabled={loading || !name || !text}
            onClick={onSubmit}
            className="button-tertiary"
          >
            {loading ? "Submitting..." : "Continue"}
          </button>
        </div>
      </Modal>
    </span>
  )
}

SuggestionModal.propTypes = {
  channelId: PropTypes.string.isRequired,
  feedbackTqaType: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  serviceName: PropTypes.string.isRequired,
}

export default SuggestionModal
